<div class="lmo-complete-stage">
  <h2>Complete Stage {{ (frac$ | async).currentStage }}</h2>
  <mat-vertical-stepper [linear]="true" #stepper *ngIf="isReady$$ | async">
    <mat-step [stepControl]="pumpedForm">
      <h3>How much sand was pumped this stage?</h3>
      <form [formGroup]="pumpedForm" class="stock-form">
        <ng-template matStepLabel>Pumped Sand</ng-template>

        <mat-card class="mb-2" *ngFor="let group of meshesInOrderGroup$ | async; trackBy: trackById">
          <mat-card-title>{{ group.meshName }}</mat-card-title>
          <mat-card-subtitle>Storage</mat-card-subtitle>
          <mat-card-content>
            <mat-form-field class="w-full" *ngFor="let mesh of group.meshes">
              <input
                sa-number-input
                matInput
                placeholder="{{ mesh.type }} Mesh lbs"
                [formControlName]="mesh.id.toString()"
                required
                autocomplete="off"
              />
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <button mat-raised-button color="primary" matStepperNext>Next</button>
      </form>
    </mat-step>
    <mat-step [stepControl]="currentStockForm">
      <ng-template matStepLabel>Current Stock</ng-template>

      <ng-container *ngIf="!(frac$ | async)?.autoStorageUpdate; else autoStorage">
        <h3>Is this stock correct?</h3>
        <h3>Please input the correct stock.</h3>
        <h3 class="warning" *ngIf="nptWarning$ | async">
          Please ensure your current stock is enough for the upcoming stage
        </h3>
        <h4 class="warning">Do not include trucks in the geofence</h4>
        <form [formGroup]="currentStockForm" class="stock-form" (keyup.enter)="sendStageComplete()">
          <mat-form-field *ngFor="let storage of storagesInOrder$ | async; trackBy: trackById">
            <input
              sa-number-input
              matInput
              placeholder="{{ storage.mesh.type }} Mesh lbs"
              [formControlName]="storage.id.toString()"
              required
              autofocus
              autocomplete="off"
            />
          </mat-form-field>
        </form>
      </ng-container>
      <ng-template #autoStorage>
        <h3>Your stock is automatically updated via API</h3>
      </ng-template>

      <button (click)="sendStageComplete()" mat-raised-button color="primary">Send Stage Complete</button>
    </mat-step>
    <mat-step *ngIf="checkForNpt$ | async" [stepControl]="emptyForm">
      <ng-template matStepLabel>Sand Shortage?</ng-template>
      <h3>Is this frac currently on NPT?</h3>
      <div class="npt-warning" [innerHTML]="nptWarningStringOne"></div>
      <div class="npt-warning" [innerHTML]="nptWarningStringTwo"></div>
      <div class="action-buttons">
        <button type="button" mat-raised-button color="warn" (click)="sendStageComplete(true)">Yes</button>
        <button type="button" mat-raised-button color="primary" (click)="backToCurrentStock()">No</button>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</div>
